import script from "./InfrarotSaunaCustomerConsent.vue?vue&type=script&setup=true&lang=js"
export * from "./InfrarotSaunaCustomerConsent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__